import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(err => {
      const hasActiveSession = !!this.authenticationService.currentUserValue?.jwtToken;
      if (err.status === 401 && hasActiveSession) {
        // logout on unauthorized response but avoid full page reload loops
        this.authenticationService.logout();
        if (!window.location.hash.startsWith('#/account/login')) {
          window.location.hash = '#/account/login';
        }
      }

      return throwError(() => err);
    }));
  }
}
